import { Form, Input, Tooltip, Typography } from 'antd';

import { SOCIAL_LABELS } from '@app/components/EditClient/components/ClientSocialAccounts/data/socialLabels';
import type { ClientDataForm } from '@app/components/EditClient/types';
import { SocialIntegrationIcon } from '@app/shared/ui/SocialIntegrationIcon';

import '@app/components/EditClient/components/ClientSocialAccounts/styles/ClientSocialAccounts.desktop.scss';

import type { FC } from 'react';

const PF = 'client-social-accounts';

const { Text } = Typography;
const { Item, List } = Form;

interface ClientSocialAccountsProps {
  disabled?: boolean;
}

export const ClientSocialAccounts: FC<ClientSocialAccountsProps> = ({
  disabled,
}) => {
  const form = Form.useFormInstance<ClientDataForm>();

  return (
    <div className={PF} data-testid="client-social-accounts">
      <Text className={`${PF}__title`}>Аккаунты в сетях</Text>
      <List name="ClientUsernames">
        {(fields) => (
          <>
            {fields.map((field) => {
              const socialType = form.getFieldValue([
                'ClientUsernames',
                field.name,
                'SocialType',
              ]) as string;
              const isEditable = form.getFieldValue([
                'ClientUsernames',
                field.name,
                'IsEditable',
              ]) as boolean | undefined;
              const label = SOCIAL_LABELS[socialType] ?? socialType;

              return (
                <Item
                  {...field}
                  key={field.key}
                  name={[field.name, 'Username']}
                  className={`${PF}__field`}
                >
                  <Input
                    size="large"
                    placeholder={label}
                    disabled={disabled || !isEditable}
                    data-testid={`client-social-account-${socialType}`}
                    prefix={
                      <Tooltip title={label}>
                        <span className={`${PF}__icon`}>
                          <SocialIntegrationIcon type={socialType} size="sm" />
                        </span>
                      </Tooltip>
                    }
                  />
                </Item>
              );
            })}
          </>
        )}
      </List>
    </div>
  );
};
